import api from './index';

export default {
  createQuestion(payload) {
    return api.post(`/questions`, { questions: payload });
  },
  listQuestions() {
    return api.get(`/questions`);
  },
  getQuestion(id) {
    return api.get(`/questions/${id}`);
  },
  updateQuestionDetail(id, payload) {
    return api.put(`/questions/${id}`, { questions: payload });
  },
  updateQuestionBulk(payload) {
    return api.put(`/questions/bulk`, { questions: payload });
  },
  updateQuestionsOrder(payload) {
    return api.put(`/questions`, { questions: payload });
  },
  deleteQuestion(id) {
    return api.delete(`/questions/${id}`);
  },
};
